
import React from 'react';
import { Clock } from '../apps/clock'

const ServiceTime = {
  title: '系统时间',
  category: '页面元素',
  icon: require('../icon/系统时间.svg'),
  component: props => {
    const { color } = props

    const style = { textAlign: 'center' }

    if (color) style['color'] = color

    return (
      <div style={style}>
        <Clock />
      </div>
    )
  },
  initLayout: { width: 100, height: 80 },
  paramSchema: {
    type: 'object',
    properties: {
      color: {
        title: '颜色',
        type: 'string',
        fieldType: 'color'
      },
    }
  }
}

export default ServiceTime
